export default __webpack_public_path__ + "static/media/board-453758_640.3ee681b9.jpg";